export const ingredientsRatio = [
  {
    group: "wheat",
    ratios: [
      { measureValue: "1", ratio: 2.5 },
      { measureValue: "2", ratio: 5 },
      { measureValue: "3", ratio: 7.5 },
      { measureValue: "4", ratio: 98.5 },
      { measureValue: "5", ratio: 120 },
      { measureValue: "6", ratio: 30 },
      { measureValue: "7", ratio: 1 },
      { measureValue: "8", ratio: 450 },
      { measureValue: "9", ratio: 1000 },
    ],
  },
  {
    group: "fuba",
    ratios: [
      { measureValue: "1", ratio: 2.6 },
      { measureValue: "2", ratio: 5.25 },
      { measureValue: "3", ratio: 7.9 },
      { measureValue: "4", ratio: 104 },
      { measureValue: "5", ratio: 126 },
      { measureValue: "6", ratio: 30 },
      { measureValue: "7", ratio: 1 },
      { measureValue: "8", ratio: 450 },
      { measureValue: "9", ratio: 1000 },
    ],
  },
  {
    group: "rice",
    ratios: [
      { measureValue: "1", ratio: 4 },
      { measureValue: "2", ratio: 8 },
      { measureValue: "3", ratio: 12 },
      { measureValue: "4", ratio: 150 },
      { measureValue: "5", ratio: 185 },
      { measureValue: "6", ratio: 30 },
      { measureValue: "7", ratio: 1 },
      { measureValue: "8", ratio: 450 },
      { measureValue: "9", ratio: 1000 },
    ],
  },
  {
    group: "oats",
    ratios: [
      { measureValue: "1", ratio: 2 },
      { measureValue: "2", ratio: 4 },
      { measureValue: "3", ratio: 6 },
      { measureValue: "4", ratio: 66 },
      { measureValue: "5", ratio: 80 },
      { measureValue: "6", ratio: 30 },
      { measureValue: "7", ratio: 1 },
      { measureValue: "8", ratio: 450 },
      { measureValue: "9", ratio: 1000 },
    ],
  },
  {
    group: "bicarbonate",
    ratios: [
      { measureValue: "1", ratio: 5 },
      { measureValue: "2", ratio: 10 },
      { measureValue: "3", ratio: 14 },
      { measureValue: "4", ratio: 184 },
      { measureValue: "5", ratio: 224 },
      { measureValue: "6", ratio: 30 },
      { measureValue: "7", ratio: 1 },
      { measureValue: "8", ratio: 450 },
      { measureValue: "9", ratio: 1000 },
    ],
  },
  {
    group: "nuts",
    ratios: [
      { measureValue: "1", ratio: 3 },
      { measureValue: "2", ratio: 6 },
      { measureValue: "3", ratio: 9 },
      { measureValue: "4", ratio: 115 },
      { measureValue: "5", ratio: 140 },
      { measureValue: "6", ratio: 30 },
      { measureValue: "7", ratio: 1 },
      { measureValue: "8", ratio: 450 },
      { measureValue: "9", ratio: 1000 },
    ],
  },
  {
    group: "starch",
    ratios: [
      { measureValue: "1", ratio: 3 },
      { measureValue: "2", ratio: 6 },
      { measureValue: "3", ratio: 8 },
      { measureValue: "4", ratio: 105 },
      { measureValue: "5", ratio: 128 },
      { measureValue: "6", ratio: 30 },
      { measureValue: "7", ratio: 1 },
      { measureValue: "8", ratio: 450 },
      { measureValue: "9", ratio: 1000 },
    ],
  },
  {
    group: "sugar",
    ratios: [
      { measureValue: "1", ratio: 4 },
      { measureValue: "2", ratio: 8 },
      { measureValue: "3", ratio: 12 },
      { measureValue: "4", ratio: 148 },
      { measureValue: "5", ratio: 180 },
      { measureValue: "6", ratio: 30 },
      { measureValue: "7", ratio: 1 },
      { measureValue: "8", ratio: 450 },
      { measureValue: "9", ratio: 1000 },
    ],
  },
  {
    group: "salt",
    ratios: [
      { measureValue: "1", ratio: 6 },
      { measureValue: "2", ratio: 12 },
      { measureValue: "3", ratio: 18 },
      { measureValue: "4", ratio: 236 },
      { measureValue: "5", ratio: 288 },
      { measureValue: "6", ratio: 30 },
      { measureValue: "7", ratio: 1 },
      { measureValue: "8", ratio: 450 },
      { measureValue: "9", ratio: 1000 },
    ],
  },
  {
    group: "chocolate",
    ratios: [
      { measureValue: "1", ratio: 2 },
      { measureValue: "2", ratio: 4 },
      { measureValue: "3", ratio: 6 },
      { measureValue: "4", ratio: 74 },
      { measureValue: "5", ratio: 90 },
      { measureValue: "6", ratio: 30 },
      { measureValue: "7", ratio: 1 },
      { measureValue: "8", ratio: 450 },
      { measureValue: "9", ratio: 1000 },
    ],
  },
  {
    group: "coffe",
    ratios: [
      { measureValue: "1", ratio: 2 },
      { measureValue: "2", ratio: 4 },
      { measureValue: "3", ratio: 5 },
      { measureValue: "4", ratio: 66 },
      { measureValue: "5", ratio: 80 },
      { measureValue: "6", ratio: 30 },
      { measureValue: "7", ratio: 1 },
      { measureValue: "8", ratio: 450 },
      { measureValue: "9", ratio: 1000 },
    ],
  },
  {
    group: "coco",
    ratios: [
      { measureValue: "1", ratio: 2 },
      { measureValue: "2", ratio: 4 },
      { measureValue: "3", ratio: 6 },
      { measureValue: "4", ratio: 82 },
      { measureValue: "5", ratio: 100 },
      { measureValue: "6", ratio: 30 },
      { measureValue: "7", ratio: 1 },
      { measureValue: "8", ratio: 450 },
      { measureValue: "9", ratio: 1000 },
    ],
  },
  {
    group: "powder",
    ratios: [
      { measureValue: "1", ratio: 2.6 },
      { measureValue: "2", ratio: 5.2 },
      { measureValue: "3", ratio: 8 },
      { measureValue: "4", ratio: 105 },
      { measureValue: "5", ratio: 128 },
      { measureValue: "6", ratio: 30 },
      { measureValue: "7", ratio: 1 },
      { measureValue: "8", ratio: 450 },
      { measureValue: "9", ratio: 1000 },
    ],
  },
  {
    group: "honey",
    ratios: [
      { measureValue: "1", ratio: 6 },
      { measureValue: "2", ratio: 12 },
      { measureValue: "3", ratio: 18 },
      { measureValue: "4", ratio: 246 },
      { measureValue: "5", ratio: 300 },
      { measureValue: "6", ratio: 30 },
      { measureValue: "7", ratio: 1 },
      { measureValue: "8", ratio: 946 },
      { measureValue: "9", ratio: 1000 },
    ],
  },
  {
    group: "cheese",
    ratios: [
      { measureValue: "1", ratio: 2 },
      { measureValue: "2", ratio: 4 },
      { measureValue: "3", ratio: 6 },
      { measureValue: "4", ratio: 74 },
      { measureValue: "5", ratio: 90 },
      { measureValue: "6", ratio: 30 },
      { measureValue: "7", ratio: 1 },
      { measureValue: "8", ratio: 450 },
      { measureValue: "9", ratio: 1000 },
    ],
  },
  {
    group: "fats",
    ratios: [
      { measureValue: "1", ratio: 4.2 },
      { measureValue: "2", ratio: 8.4 },
      { measureValue: "3", ratio: 12.5 },
      { measureValue: "4", ratio: 165 },
      { measureValue: "5", ratio: 200 },
      { measureValue: "6", ratio: 30 },
      { measureValue: "7", ratio: 1 },
      { measureValue: "8", ratio: 450 },
      { measureValue: "9", ratio: 1000 },
    ],
  },
  {
    group: "peanutb",
    ratios: [
      { measureValue: "1", ratio: 5.4 },
      { measureValue: "2", ratio: 10.8 },
      { measureValue: "3", ratio: 16 },
      { measureValue: "4", ratio: 212 },
      { measureValue: "5", ratio: 258 },
      { measureValue: "6", ratio: 30 },
      { measureValue: "7", ratio: 1 },
      { measureValue: "8", ratio: 450 },
      { measureValue: "9", ratio: 1000 },
    ],
  },
  {
    group: "liquid",
    ratios: [
      { measureValue: "1", ratio: 5 },
      { measureValue: "2", ratio: 10 },
      { measureValue: "3", ratio: 15 },
      { measureValue: "4", ratio: 190 },
      { measureValue: "5", ratio: 240 },
      { measureValue: "6", ratio: 30 },
      { measureValue: "7", ratio: 1 },
      { measureValue: "8", ratio: 946 },
      { measureValue: "9", ratio: 1000 },
    ],
  },
]

function formatOutput(number) {
  const isDecimal = number.toString().split(".").length > 1 ? true : false
  if (isDecimal) {
    return number.toFixed(2)
  } else {
    return number
  }
}

export function getConversionResult(group, measure1, measure2, value) {
  const measure1ratio = ingredientsRatio
    .filter(item => item.group === group)[0]
    .ratios.filter(item => item.measureValue === measure1)[0].ratio
  const measure2ratio = ingredientsRatio
    .filter(item => item.group === group)[0]
    .ratios.filter(item => item.measureValue === measure2)[0].ratio
  const output = formatOutput((value * measure1ratio) / measure2ratio)
  return output
}

export function getMeasures(ingredient, solid, liquid) {
  const ratios = ingredientsRatio.filter(
    item => item.group === ingredient.group
  )[0].ratios
  if (ingredient.type === "solid") {
    const labelRatios = solid.map(item => {
      const ratio = ratios.filter(line => line.measureValue === item.value)[0]
        .ratio
      return {
        label: item.label,
        ratio,
      }
    })
    return labelRatios
  } else {
    const labelRatios = liquid.map(item => {
      const ratio = ratios.filter(line => line.measureValue === item.value)[0]
        .ratio
      return {
        label: item.label,
        ratio,
      }
    })
    return labelRatios
  }
}

export function getConversionDegrees(scalePrimary, scaleSecondary, value) {
  let result
  let valueNumber = Number(value)
  if (scalePrimary === "1") {
    if (scaleSecondary === "2") {
      result = (valueNumber / 5) * 9 + 32
    } else if (scaleSecondary === "3") {
      result = valueNumber + 273.15
    } else {
      result = valueNumber
    }
  }
  if (scalePrimary === "2") {
    if (scaleSecondary === "1") {
      result = (valueNumber - 32) * (5 / 9)
    } else if (scaleSecondary === "3") {
      result = (valueNumber - 32) * (5 / 9) + 273.15
    } else {
      result = valueNumber
    }
  }
  if (scalePrimary === "3") {
    if (scaleSecondary === "1") {
      result = valueNumber - 273.15
    } else if (scaleSecondary === "2") {
      result = (valueNumber - 273.15) * (9 / 5) + 32
    } else {
      result = valueNumber
    }
  }
  return formatOutput(result)
}
